import { NO_COUNTERPARTY_LABEL } from "@common/constants/domains/accounting/schedules";
import { FiltersTypes } from "@common/types/filters/general";
import { Counterparty } from "@common/types/counterparty";

export type CounterpartiesFilters = Pick<
    FiltersTypes,
    | "counterpartiesIds"
    | "withEmptyOrUnverifiedCounterparty"
    | "hasCounterparty"
>;

export const HAS_COUNTERPARTY_LABEL = "Has counterparty";
export function getCounterpartyPresenceLabels(entityLabel?: string) {
    if (!entityLabel) {
        return {
            hasAssignedLabel: HAS_COUNTERPARTY_LABEL,
            emptyLabel: NO_COUNTERPARTY_LABEL,
            noMatchLabel: "No matching counterparty",
        };
    }

    const noun = entityLabel.toLowerCase();
    return {
        hasAssignedLabel: `Has ${noun}`,
        emptyLabel: `No ${noun}`,
        noMatchLabel: `No matching ${noun}`,
    };
}

export type CounterpartiesWithEmptyValue = Array<{
    counterparty: Counterparty | null;
}>;
